import Config from 'config/config';

/**
 * Read by the generated ViveApi client (`src/app/shared/vive-api/vive-api.config.ts`),
 * which imports it from this path. Everything else reads `config/config.ts`.
 *
 * Do NOT add `authCookieName`: the client treats its presence as legacy mode and
 * sends a JavaScript-held Bearer token. Without it the client stays in session
 * mode and the HttpOnly session cookie authenticates every request.
 */
export const environment = {
  apiBaseUrl: Config.getEnvironmentConfig().viveApiUrl
};
